import {ResourceConfig, SoftDeleteResource} from "@hidat/huijs-resource";
import {FieldConfig, FieldDataTypes, uNumber, uString, Uuid} from "@hidat/huijs-common";
import {HasBinResource, RblFieldConfigs, RblTenantResourceInterface} from "../rbl-resource.interface";

export const ListConfig = new ResourceConfig('List', 'lists', true, true)
  .addFields([
    RblFieldConfigs.id,
    RblFieldConfigs.uid,
    RblFieldConfigs.bin,
    RblFieldConfigs.createdAt,
    RblFieldConfigs.createdById,
    RblFieldConfigs.name.setRequired(true),
    new FieldConfig('shortCode'),
    new FieldConfig('prototype'),
    new FieldConfig('allowDuplicates', FieldDataTypes.BOOLEAN),
    new FieldConfig('isOrdered', FieldDataTypes.BOOLEAN),
    new FieldConfig('trackChanges', FieldDataTypes.BOOLEAN),
    new FieldConfig('itemCount', FieldDataTypes.INTEGER).setEditable(false)
  ])
.setSorts({
  name: 'name',
  createdat: 'createdAt',
})
.setDefaultSort('createdat-')

export type ListPrototypes = "General" | "Candidate" | "Playlist" | "ContentUpdate";

export interface ListInterface extends RblTenantResourceInterface, SoftDeleteResource, HasBinResource {
  uid: Uuid | undefined;
  name: uString;
  shortCode: uString;
  prototype: ListPrototypes | undefined;   //list_klass
  allowDuplicates: boolean | undefined;
  isOrdered: boolean | undefined;
  trackChanges: boolean | undefined;
  itemCount: uNumber;
}
